exports = function(str, prefix) {
    return str.indexOf(prefix) === 0;
};

module.exports = exports;
